import React from 'react';
import { Router, Route, IndexRoute } from 'react-router';

import Template from '../template/View';
import Home from '../home/View';
import About from '../about/View';
import Research from '../research/View';

const Routes = props => (
  <Router {...props}>
    <Route path="/" component={Template}>
      <IndexRoute component={Home} />
      <Route
        path="/about"
        component={About}
      />
      <Route
        path="/research"
        component={Research}
      />
    </Route>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/config/Routes.js